import classNames from 'classnames';
import styles from './Link.module.scss';
import { Icon } from 'ui/components';
import ChevronLeft from 'ui/icons/icon-chevron-left.svg';
import ChevronRight from 'ui/icons/icon-chevron-right.svg';
import { NextLink } from './NextLink/NextLink';
import { MouseEventHandler } from 'react';
import IconArrowRight from 'ui/icons/icon-arrow-right-web.svg';
import IconArrowLeft from 'ui/icons/icon-arrow-right-web.svg';

export interface LinkProps {
	children: React.ReactNode;
	style?: 'primary' | 'sm' | 'underline' | 'secondary';
	ariaLabel?: string;
	className?: string;
	url?: string;
	locale?: string;
	target?: string;
	asText?: boolean;
	chevron?: 'before' | 'after' | 'none';
	handleClick?: MouseEventHandler<HTMLAnchorElement> | (() => void) | void;
	role?: string;
	props?: any;
	variant?: 'default' | 'website';
}

export const Link: React.FC<LinkProps> = ({
	children,
	style,
	ariaLabel,
	className,
	url,
	locale,
	target,
	asText,
	chevron,
	variant = 'default',
	handleClick,
	props,
}) => {
	return (
		<>
			{asText ? (
				<p className={classNames(styles.Link, styles[`Link___${style}`], className)}>{children}</p>
			) : (
				<NextLink
					href={url}
					locale={locale}
					target={target ?? '_self'}
					aria-label={ariaLabel}
					className={classNames(styles.Link, styles[`Link___${style}`], styles[`Link___${variant}`], className, {
						[styles.Link___chevron]: chevron,
					})}
					onClick={handleClick}
					{...props}
				>
					{variant === 'default' && chevron === 'before' && (
						<Icon className={styles.Link_chevron}>
							<ChevronLeft />
						</Icon>
					)}
					{children}
					{variant === 'default' && chevron === 'after' && (
						<Icon className={styles.Link_chevron}>
							<ChevronRight />
						</Icon>
					)}
					{variant === 'website' && chevron === 'before' && (
						<Icon size="lg" className={styles.Link_arrow}>
							<IconArrowLeft />
						</Icon>
					)}
					{variant === 'website' && chevron === 'after' && (
						<Icon size="lg" className={styles.Link_arrow}>
							<IconArrowRight />
						</Icon>
					)}
				</NextLink>
			)}
		</>
	);
};
